import { render, staticRenderFns } from "./khoranaCalculator.vue?vue&type=template&id=361276b4&scoped=true"
import script from "./khoranaCalculator.vue?vue&type=script&lang=js"
export * from "./khoranaCalculator.vue?vue&type=script&lang=js"
import style0 from "./khoranaCalculator.vue?vue&type=style&index=0&id=361276b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361276b4",
  null
  
)

export default component.exports